import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { useSelector } from "react-redux";
import { SelectorCharacterUI } from "../introduction/SelectorCharacterUI";
import { useNavigate } from "react-router-dom";
import { DialogBarNew } from "../../components/common/DialogBarNew";
import { ButtonPlay } from "../../components/common/ButtonPlay";
import { ButtonHome } from "../../components/common/ButtonHome";
import { audiosAssets } from "../../assets/audio";
import { voicesTypeControl } from "../../types/audioType";

const steps = {
	introduction: 1,
	interfaceInfo: 2,
	selectCharacter: 3,
	dialogOne: 4,
	dialogTwo: 5,
	dialogThree: 6,
	dialogFour: 7,
	dialogFive: 8,
};
export const IntroductionTema4 = () => {
	const { loaded } = useSelector((state) => state.menu);
	const navigation = useNavigate();
	const [uiToShow, setUiToShow] = useState(steps.selectCharacter);
	useEffect(() => {
		if (loaded) {
			console.log("introduction tema 4");
			ObserverEmitter.emit(EVENTS.init_introduction);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.introduccion.int01)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
			</>
			{uiToShow === steps.selectCharacter && (
				<SelectorCharacterUI
					callback={() => {
						setUiToShow(steps.dialogOne);
						// ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesTeam1Assets.introduction.one)
						ObserverEmitter.emit(EVENTS.final_instructions);
						ObserverEmitter.emit(EVENTS.move_escritorio_introduction);
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.introduccion.int01)
					}}
				></SelectorCharacterUI>
			)}
			{uiToShow === steps.dialogOne && (
				<DialogBarNew
					dialog={
						"¡Hola! Nos alegra que sigas con nosotros. A continuación, exploraremos las actividades de un colaborador en tienda para que las apliques en tu día a día."
					}
					percentage={"20%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.characterAnimations.idle);
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.introduccion.int02)
						setUiToShow(steps.dialogTwo);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogTwo && (
				<DialogBarNew
					dialog={
						"Hemos llegado a la tienda base. En esta ocasión toca realizar actividades y misiones del punto de venta las cuales te darán puntos."
					}
					percentage={"40%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.characterAnimations.idle);
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.introduccion.int03)
						setUiToShow(steps.dialogThree);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogThree && (
				<DialogBarNew
					dialog={
						"Y al finalizar las actividades de esta tienda obtendrás una recompensa."
					}
					percentage={"60%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.characterAnimations.idle);
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.introduccion.int04)
						setUiToShow(steps.dialogFour);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogFour && (
				<DialogBarNew
					dialog={
						"Nos hace falta personal, nuestras ventas han bajado desde entonces ya que nadie la atiende como debería."
					}
					percentage={"80%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.characterAnimations.idle);
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.introduccion.int05)
						setUiToShow(steps.dialogFive);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogFive && (
				<DialogBarNew
					dialog={
						"Con tus conocimientos y habilidades, estoy seguro de que podemos volver a la normalidad ¿Podrás ayudarnos?"
					}
					percentage={"100%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						navigation("/home4/tema4/subtema1/activityOne");
					}}
				></DialogBarNew>
			)}
		</>
	);
};